<script>
import {Message} from 'element-ui'
  export default {
    data () {
      return {
        content: '',
      }
    },
    mounted () {

    },
    methods: {
      onKeyup (e) {
        let keynum = (e.keyCode ? e.keyCode : e.which)
        if (keynum === 13 && this.content.length) {
          let that = this
          let text=that.content.trim()
          let session = this.$store.getters['session']
          if (session.id == null) {
            Message({
              showClose: true,
              message: '请先选择一个对话',
              type: 'warning'
            })
            this.content=''
            return false
          }
          if (text.length>0) {
            let msg = {
              userId: 0,
              platformId: session.platformId,
              platformOrderNo: session.platformOrderNo,
              content: text
            }
            let jsonMsg = JSON.stringify(msg)
            that.$store.dispatch('socketSend', jsonMsg)
            this.content = ''
          }else {
            that.content=''
          }
        }
      }
    }
  }
</script>

<template>
  <div class="text">
    <textarea placeholder="按 Enter 发送" v-model="content" @keyup="onKeyup"></textarea>
  </div>
</template>

<style lang="less" scoped>
  .text {
    height: 160px;
    border: solid 1px #ddd;

    textarea {
      padding: 10px;
      height: ~'calc(100% - 20px)';
      width: ~'calc(100% - 22px)';
      border: none;
      outline: none;
      font-family: "Micrsofot Yahei";
      resize: none;
    }
  }
</style>
